<template>
  <div class="invoice-list-wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    
    <!-- 搜索表单 -->
    <div class="search-form-container">
      <el-form
          ref="form"
          inline
          :model="searchData"
          class="search-form"
      >
        <el-form-item label="订单号">
          <el-input
              v-model="searchData.order_no"
              placeholder="请输入订单号"
              size="small"
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="税号">
          <el-input
              v-model="searchData.tax_number"
              placeholder="请输入税号"
              size="small"
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input
              v-model="searchData.product_name"
              placeholder="请输入商品名称"
              size="small"
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="是否开票">
          <el-select
              v-model="searchData.has_invoice"
              placeholder="请选择是否开票"
              size="small"
              clearable
              class="invoice-select"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-buttons">
          <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="getList"
          >搜索</el-button>
          <el-button
              type="info"
              size="small"
              icon="el-icon-refresh"
              plain
              @click="reset"
          >重置</el-button>
          <el-button
              type="success"
              size="small"
              icon="el-icon-download"
              plain
              :disabled="!selectedRows.length"
              @click="exportData"
          >导出选中</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <el-table 
        :data="list"
        border
        stripe
        class="invoice-table"
        v-loading="loading"
        @selection-change="handleSelectionChange"
    >
      <el-table-column
          type="selection"
          width="55"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="name"
          label="抬头"
          min-width="120"
          show-overflow-tooltip
      ></el-table-column>
      <el-table-column
          prop="tax_number"
          label="税号"
          min-width="150"
          show-overflow-tooltip
      ></el-table-column>
      <el-table-column
          prop="contact_person"
          label="联系人"
          min-width="100"
      ></el-table-column>
      <el-table-column
          prop="email"
          label="邮箱"
          min-width="150"
          show-overflow-tooltip
      ></el-table-column>

      <el-table-column
          label="订单信息"
          min-width="200"
      >
        <template slot-scope="{ row }">
          <div class="order-info">
            <div class="info-row">
              <span class="label">订单编号：</span>
              <span class="value">{{ row?.order?.order_no }}</span>
            </div>
            <div class="info-row">
              <span class="label">产品名称：</span>
              <span class="value">{{ row?.order?.product_name }} {{ row?.order?.order_price }}元/{{ row?.order?.year }}年</span>
            </div>
            <div class="info-row">
              <span class="label">支付方式：</span>
              <span class="value">{{ row?.order?.pay_type_dsc }}</span>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
          label="发票"
          min-width="80"
          align="center"
      >
        <template slot-scope="{ row }">
          <span v-if="!row.download_url" class="no-invoice">暂无</span>
          <el-button 
              v-else 
              type="text"
              size="small"
              icon="el-icon-download"
              @click="handleDownload(row.download_url)"
          >下载</el-button>
        </template>
      </el-table-column>

      <el-table-column
          prop="status_dsc"
          label="开票状态"
          min-width="120"
          align="center"
      ></el-table-column>

      <el-table-column
          prop="created_at"
          label="申请日期"
          min-width="150"
          align="center"
      ></el-table-column>

      <el-table-column
          label="操作"
          width="200"
          fixed="right"
          align="center"
      >
        <template slot-scope="{ row }">
          <el-button
              type="primary"
              size="mini"
              icon="el-icon-upload2"
              @click="showUploadInvoice(row)"
          >上传</el-button>
          <el-button
              type="danger"
              size="mini"
              icon="el-icon-refresh-left"
              @click="handleRefund(row)"
              style="margin-left: 5px;"
          >退款</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <pagination
          :total="total"
          :page.sync="searchData.page"
          :limit.sync="searchData.pagesize"
          @pagination="getList"
      />
    </div>

    <!-- 上传发票弹窗 -->
    <el-dialog
        title="上传发票"
        :visible.sync="dialogVisible"
        width="500px"
        :close-on-click-modal="false"
        :before-close="handleClose"
    >
      <uploader-video @update:videoUrl="uploadInvoice"></uploader-video>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getListAPI, getDetailAPI, uploadInvoiceAPI, refundAPI} from './api'
import {authBtnMixin} from '@/mixins/authBtnMixin'
import UploaderVideo from "@/components/uploader/uploader-video.vue";

export default {
  name: 'Index',
  components: {UploaderVideo},
  mixins: [authBtnMixin],
  data() {
    return {
      loading: false,
      selectedRows: [],
      rules: [{required: true, message: '该项不能为空', trigger: 'blur'}],
      show_detail: false,
      show_review: false,
      dialogVisible: false,
      list: [],
      city_list: [],
      searchData: {
        page: 1,
        pagesize: 10,
        order_no: '',
        tax_number: '',
        product_name: '',
        has_invoice: '',
        pay_type: null,
        pay_status: null
      },
      total: 0,
      changeStatusData: {
        id: '',
        status: null
      },
      uploadInvoiceFormData: {
        id: 0,
        download_url: ''
      },
    }
  },
  provide() {
    return {
      context: this
    }
  },
  mounted() {
    this.getList()
  },

  methods: {
    handleDownload(url) {
      if (!url) {
        this.$message.warning('下载链接不存在')
        return
      }
      // 创建一个临时的a标签来触发下载
      const link = document.createElement('a')
      link.href = url
      link.download = ''
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    exportData() {
      if (!this.selectedRows.length) {
        this.$message.warning('请选择要导出的数据')
        return
      }
      const params = {
        ...this.searchData,
        ids: this.selectedRows.map(row => row.id)
      }
      this.$fn.downloadHandle(params, '/api/api/manage/user/invoice/download', '发票管理', 'post')
    },
    async handleDetail({id}) {
      this.detail = await getDetailAPI(id)
      this.show_detail = true
    },
    handleClose() {
      this.dialogVisible = false
      this.uploadInvoiceFormData = {
        id: 0,
        download_url: ''
      }
    },
    uploadInvoice(res) {
      this.uploadInvoiceFormData.download_url = res.url
      uploadInvoiceAPI(this.uploadInvoiceFormData).then(res => {
        this.$message.success('上传成功')
        this.getList()
        this.dialogVisible = false
        this.uploadInvoiceFormData = {
          id: 0,
          download_url: ''
        }
      })
    },
    showUploadInvoice({id}) {
      this.uploadInvoiceFormData.id = id
      this.dialogVisible = true
    },
    handleRefund(row) {
      this.$confirm('确认要对此发票进行退款操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        refundAPI(row.id).then(() => {
          this.$message.success('退款操作成功')
          this.getList()
        }).catch(() => {
          this.$message.error('退款操作失败')
        })
      }).catch(() => {
        this.$message.info('已取消退款操作')
      })
    },
    async getList() {
      this.loading = true
      try {
        const params = {...this.searchData}
        const res = await getListAPI(params)
        this.list = res.data || []
        this.total = res.total || 0
      } catch (error) {
        console.error('获取列表失败:', error)
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData)
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-list-wrapper {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);

  .search-form-container {
    padding: 20px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 20px;

    .search-form {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .el-form-item {
        margin-bottom: 0;
        margin-right: 20px;
      }

      .payment-select {
        width: 200px;
      }

      .invoice-select {
        width: 150px;
      }

      .search-buttons {
        margin-right: 0;
        .el-button {
          margin-left: 10px;
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
  }

  .invoice-table {
    margin: 20px 0;
    .order-info {
      padding: 8px 0;
      .info-row {
        display: flex;
        line-height: 24px;
        
        .label {
          color: #606266;
          width: 70px;
          text-align: right;
          margin-right: 8px;
        }
        
        .value {
          color: #303133;
          flex: 1;
        }
      }
    }

    .no-invoice {
      color: #909399;
    }
  }

  .pagination-container {
    padding: 20px 0;
    text-align: right;
  }
}
</style>
